export default {
  web: {
    common: {
      for: "per",
      today: "Oggi",
      unknown: "Sconosciuto",
      checkout: "Vai alla cassa",
      noOdds: "Nessuna quota",
    },
    navigation: {
      tools: "Strumenti",
      getLinematePlus: "Ottieni Linemate+",
      startFreeTrial: "Inizia la prova gratuita",
      downloadLinemate: "Scarica Linemate",
      profileSettings: "Impostazioni profilo",
      closeMyPicks: "Chiudi Le mie scelte",
      offSeason: "{{league}} è fuori stagione. Ci vediamo la prossima stagione.",
      search: {
        teams: "Squadre",
        noResultsFor: "Nessun risultato trovato per \"{{searchTerm}}\"",
      },
      toolsMenu: {
        opponentDefensiveRank: "Ranking difensivo avversario",
        startingOpponentPitchers: "Lanciatori partenti avversari",
      },
    },
    toastModal: {
      title: "Novità",
      items: {
        checkout: "Vai al tuo book preferito con Le mie scelte.",
        preferredOdds: "Visualizza le quote dei trend con le tue quote preferite (disponibile per utenti Linemate+).",
      },
      actions: {
        dismiss: "Chiudi",
      },
    },
    carousel: {
      previous: "Precedente",
      next: "Successivo",
    },
  },
};
